<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="case-2">
<h1>Case 2</h1>
<div class="section level21" id="clinical-presentation-1">
<p style="padding-bottom:6px; letter-spacing:1px;padding-top:28px;font-weight:bold;text-indent:0px;">Clinical Presentation</p>
<p style="text-indent:0px;">A 61-year-old man known diabetic type 2 presented with 1-year history of paroxysmal attacks of palpitation, dizziness and headache. The physical examination was normal except the blood pressure which was high during paroxysmal attack (systolic BP varies from 150 to 230 mmHg and diastolic BP varies from 110 to</p>
<p style="text-indent:0px;">140 mmHg). The routine laboratory investigations were within normal limits except the glycaemia at 200 mg/Dl. The serum catecholamine level was not done.</p>
</div>
<div class="section level21" id="radiological-findings-1">
<p style="padding-bottom:6px; letter-spacing:1px;padding-top:28px;font-weight:bold;text-indent:0px;">Radiological Findings</p>
<p style="text-align: center;"><img alt="2" src="media/2.png"/></p>
<p style="padding-top: 0px; text-align: center;"></p>
<ul style="list-style:none;padding-right:100px;padding-left:115px;margin-top:0px;"><li>
<p style="text-indent:20px;"><strong>Enhanced abdominal CT scan, post-contrast arterial phase axial (A, B) / coronal and sagittal reconstruction (C, D, E) and post-contrast portal phase axial (F) images</strong> reveal a well-defined lobulated right suprarenal mass with intense and heterogeneous enhancement and prominent surrounding vessels on arterial phase and rapid washout on portal phase. Note the IVC is displaced anteriorly and the upper pole of the kidney posteriorly. The left adrenal gland appears normal in size and shape (arrow image A).</p></li></ul>
<p style="text-indent:0px;padding-top:15px;"><strong>Diagnosis:</strong> Adrenal Pheochromocytoma</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch008.vue?549c6ea9